export default __webpack_public_path__ + "two-col-delivery-tile.725ac4083fda2269fd59e7734e6e1d41.png";